const baseStyleText = (props) => {
    const { colorScheme } = props;
    return {
        fontSize: "sm",
        fontWeight: "normal",
        lineHeight: "base",
        color: colorScheme === "warning" ? `${colorScheme}.600` : "danger.700",
    };
};
const baseStyle = (props) => ({
    text: baseStyleText(props),
});
const defaultProps = {
    colorScheme: "danger",
};
const FormError = {
    baseStyle,
    defaultProps,
};
export default FormError;
